import crossIcon from './image/crossIcon.png';
import searchIcon from './image/searchIcon.png';
import person from './image/person.png';

export const friendIcon = {
    crossIcon: crossIcon,
    searchIcon: searchIcon,
}

export const friendProfileImg = person;